/* Video scroller block — fullscreen playback on click.
   Loaded as an ES module, so the browser executes it once per URL. */
(function () {
  if (window.__videoScrollerInit) return;
  window.__videoScrollerInit = true;

  let modal;

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'video-scroller-modal';
    modal.innerHTML =
      '<div class="video-scroller-modal__inner">' +
      '<button type="button" class="video-scroller-modal__close" aria-label="Close">&times;</button>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('video-scroller-modal__close')) {
        closeModal();
      }
    });
    return modal;
  }

  function closeModal() {
    if (!modal || !modal.classList.contains('is-open')) return;
    const playing = modal.querySelector('.video-scroller-modal__video');
    if (playing) {
      playing.pause();
      playing.remove();
    }
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function openModal(sourceVideo) {
    const m = buildModal();
    const inner = m.querySelector('.video-scroller-modal__inner');
    const existing = inner.querySelector('.video-scroller-modal__video');
    if (existing) existing.remove();

    const video = document.createElement('video');
    video.className = 'video-scroller-modal__video';
    video.setAttribute('controls', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.muted = false;
    if (sourceVideo.getAttribute('poster')) {
      video.setAttribute('poster', sourceVideo.getAttribute('poster'));
    }

    // Size the modal video up front so it doesn't resize once metadata
    // loads. The thumbnail is already playing, so its real dimensions are
    // usually known already; fall back to the markup width/height attrs.
    let w = sourceVideo.videoWidth;
    let h = sourceVideo.videoHeight;
    if ((!w || !h) && sourceVideo.getAttribute('width') && sourceVideo.getAttribute('height')) {
      w = parseInt(sourceVideo.getAttribute('width'), 10);
      h = parseInt(sourceVideo.getAttribute('height'), 10);
    }
    if (w && h) {
      const maxW = window.innerWidth * 0.9;
      const maxH = window.innerHeight * 0.9;
      const ratio = w / h;
      let width, height;
      if (maxW / maxH > ratio) {
        height = maxH;
        width = maxH * ratio;
      } else {
        width = maxW;
        height = maxW / ratio;
      }
      video.style.width = Math.round(width) + 'px';
      video.style.height = Math.round(height) + 'px';
    }

    sourceVideo.querySelectorAll('source').forEach(function (s) {
      video.appendChild(s.cloneNode(true));
    });

    inner.appendChild(video);
    m.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';

    const p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  document.addEventListener('click', function (e) {
    const item = e.target.closest('[data-video-open]');
    if (!item) return;
    const video = item.querySelector('video');
    if (!video) return;
    e.preventDefault();
    openModal(video);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
